import { Flex, useMobileMediaQuery } from '@iheartjane/reefer';
import type { PriceId } from '@iheartjane/types';

import type { WeightSelectorWeight } from '@jane/shared-ecomm/types';
// eslint-disable-next-line no-restricted-imports
import type { MenuProduct, ReservationCartProduct } from '@jane/shared/models';
import {
  getTotalOriginalAndDiscountedPrices,
  isSoldByWeight,
} from '@jane/shared/util';

import { DisplayMode, useProductCardContext } from '../../productCardProvider';
import Confirmation from './confirmation';
import { StyledActionCardContent } from './listViewProductCard.styles';
import WeightSelectorContainer from './weightSelectorContainer';

interface ActionCardContentProps {
  isAd: boolean;
  noSelectedWeightDefault: boolean;
  onWeightSelected: (selectedWeight: PriceId) => void;
  selectedWeight: PriceId;
  weights: WeightSelectorWeight[];
}

const ActionCardContent = ({
  noSelectedWeightDefault,
  onWeightSelected,
  selectedWeight,
  weights,
  isAd,
}: ActionCardContentProps) => {
  const { cartProduct, displayMode, menuProduct } = useProductCardContext();
  const isMobile = useMobileMediaQuery({});
  const { totalOriginalPrice, totalDiscountedPrice } =
    getTotalOriginalAndDiscountedPrices({
      menuProduct: menuProduct as MenuProduct,
      cartProduct: cartProduct as ReservationCartProduct[],
    });

  return (
    <StyledActionCardContent
      background={
        displayMode === DisplayMode.Confirmation
          ? 'grays-ultralight'
          : 'grays-white'
      }
    >
      <Flex
        flexDirection="column"
        alignItems={
          displayMode === DisplayMode.Confirmation ? 'center' : 'flex-end'
        }
        justifyContent="center"
        grow={2}
        height="100%"
        pt={
          isAd && !isMobile && displayMode !== DisplayMode.Confirmation ? 40 : 0
        }
      >
        {displayMode === DisplayMode.Confirmation && (
          <Confirmation
            discountedPrice={totalDiscountedPrice}
            onWeightSelected={onWeightSelected}
            originalPrice={totalOriginalPrice}
          />
        )}
        {(displayMode === DisplayMode.Product ||
          displayMode === DisplayMode.Edit) && (
          <WeightSelectorContainer
            isSoldByWeight={
              menuProduct ? isSoldByWeight(menuProduct.kind) : false
            }
            noSelectedWeightDefault={noSelectedWeightDefault}
            onWeightSelected={onWeightSelected}
            selectedWeight={selectedWeight}
            weights={weights}
          />
        )}
      </Flex>
    </StyledActionCardContent>
  );
};

export default ActionCardContent;
